import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { StyledTextBox } from "@animech/ui";

export const FieldWithButton = styled.div``;
export const Text = styled.p``;
export const RequestFailedText = styled.p``;

export const Templates = styled.div``;
export const Template = styled.div``;
export const TemplateName = styled.span``;
export const TemplateDescription = styled.span``;

export const OpenDesignModalContent = styled.div`
	${({ theme }) => css`
		overflow: hidden;
		display: flex;
		flex-direction: column;

		${RequestFailedText} {
			margin: 8px 0;
			color: #ff4040;
		}

		${Templates} {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: ${theme.dimensions.margin.base};
			margin-top: ${theme.dimensions.margin.base};
			overflow-y: auto;
		}

		${Template} {
			display: flex;
			flex-direction: column;
			margin-bottom: ${theme.dimensions.margin.large};
			cursor: pointer;

			img {
				max-width: 100%;
			}

			font-weight: 400;
			line-height: 26px;
			text-align: center;

			${TemplateName} {
				font-size: 20px;
				margin-bottom: ${theme.dimensions.margin.base};
			}
			${TemplateDescription} {
				font-size: 17px;
			}
		}

		${FieldWithButton} {
			background-color: ${theme.colors.palette.grey[100]};
			display: flex;

			${StyledTextBox.Root} {
				flex-grow: 1;
			}
		}
	`}
`;
